import * as React from 'react';
//import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Container, Row, Col, Button, Table, Spinner, ButtonGroup, Modal, Form, Dropdown, DropdownButton, InputGroup, FormControl } from 'react-bootstrap';
import { FaPlayCircle, FaForward, FaStopCircle, FaTimesCircle, FaListUl, FaRedoAlt, FaEye, FaSearch } from "react-icons/fa";
import Swal from 'sweetalert2'
import { ApplicationState } from "../../store";
import { connect } from "react-redux";
import { formatYMDToDMY, taskStatusColour, resetFormatDMY } from '../modules/Common'
import * as LegacyReportModels from '../../models/report/LegacyReport'
import * as LegacyReportStore from '../../store/report/LegacyReport'
import * as LoadingStore from '../../store/Loading'
import * as LoadingModels from '../../models/config/Loading'

type Store = LegacyReportModels.GetLegacyReportState & typeof LegacyReportStore.actionCreators | LoadingModels.LoadingState & typeof LoadingStore.actionCreators

class LegacyReportTable extends React.Component<any, { response: Array<LegacyReportModels.LegacyReport>, isready: boolean, companyCode: any, checkready: boolean, formData: Array<LegacyReportModels.LegacyReport>, checkActive: boolean, checkReload: boolean, checkFilter: boolean, checkError: boolean, checkSuspend: boolean, keyFilter: string, isShowTempModal: boolean, isSelectVal: any, isShowAlertConfirmModal: boolean, passwordFromApi: string }, Store> {
    constructor(props: any) {
        super(props);
        this.state = {
            response: [],
            isready: true,
            companyCode: [],
            checkready: true,
            formData: [],
            checkActive: false,
            checkFilter: false,
            checkError: false,
            checkSuspend: false,
            checkReload: true,
            keyFilter: '',
            isShowTempModal: false,
            isShowAlertConfirmModal: false,
            isSelectVal: null,
            passwordFromApi: ""
        }
        this.runImmediatelyHandleClick = this.runImmediatelyHandleClick.bind(this);
        this.continuteHandleClick = this.continuteHandleClick.bind(this);
        this.handleActive = this.handleActive.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
    }

    componentDidMount() {
        // The backend now always scopes report results to the deployment's single company,
        // so there is no need to look up the user's company list first.
        this.getLegacyReport([])
    }

    getLegacyReport(companyCodeUse) {
        console.log('call function getLegacyReport')
        console.log(companyCodeUse)
        var dataset: any = []

        companyCodeUse.map((item) => {
            dataset.push(item.company_code)
        })

        this.setState({
            companyCode: dataset
        })
        console.log(this.state.companyCode)

        const { isready } = this.state
        if (isready) {
            this.props.requestGetLegacyReport(isready, "POST", "", dataset)
        }
    }

    componentDidUpdate(nextProps: any, nextState: any) {
        const { isLoadLegacyReport, responseLegacyReport, statusLegacyReport, GetReport, checkkey, search } = this.props
        const { isready, checkready, companyCode } = this.state
        if (!isready && checkready && GetReport.isLoadLegacyReport && GetReport.statusLegacyReport == 200 && GetReport.responseLegacyReport != undefined) {
            this.setState({
                response: GetReport.responseLegacyReport['result_list'],
                checkready: false
            })
            this.props.callbackkey()
        }

        if (search == "Search") {
            this.handleSearchDataReport()
        }

        if (checkkey == "reset" && checkkey != undefined && !this.state.checkready) {
            this.props.requestGetLegacyReport(true, "CLEAR", "", "")
            console.log(checkkey)
            this.setState({
                formData: [],
                checkready: true,
                isready: true,
            })
            this.props.requestGetLegacyReport(true, "POST", "", companyCode)
        }

        if (checkkey == "Active") {
            this.setState({
                checkReload: false,
                checkActive: true
            })
            this.handleActive()
        } else if (checkkey == "UnActive") {
            this.props.callbackkey()
            this.setState({
                formData: GetReport.responseLegacyReport['result_list'],
                checkActive: false,
                checkReload: true
            })
            if (this.state.checkFilter) {
                this.handleFilter()
            }
            this.forceUpdate()
        } else if (checkkey == "CheckFilter") {
            console.log('handleFilter Checked!')
            this.setState({
                keyFilter: this.props.filterKey,
                checkReload: false,
                checkFilter: true
            })
            this.handleFilter()
        } else if (checkkey == "UnCheckFilter") {
            console.log('handleFilter UnChecked!')
            this.props.callbackkey()
            this.setState({
                formData: GetReport.responseLegacyReport['result_list'],
                checkFilter: false,
                checkReload: true
            })
            //if (this.state.checkFilter) {
            //    this.handleActive()
            //}
            this.forceUpdate()
        } else if (checkkey == "Suspend") {
            console.log('handleSuspend Checked!')
            this.setState({
                checkReload: false,
                checkSuspend: true
            })
            this.handleSuspend()
        } else if (checkkey == "UnSuspend") {
            console.log('handleSuspend UnChecked!')
            this.props.callbackkey()
            this.setState({
                formData: GetReport.responseLegacyReport['result_list'],
                checkSuspend: false,
                checkReload: true
            })
        } else if (checkkey == "Error") {
            console.log('handleError Checked!')
            this.setState({
                checkReload: false,
                checkError: true
            })
            this.handleError()
        } else if (checkkey == "UnError") {
            console.log('handleError UnChecked!')
            this.props.callbackkey()
            this.setState({
                formData: GetReport.responseLegacyReport['result_list'],
                checkError: false,
                checkReload: true
            })
        }

        if (GetReport.statusLegacyReport == 200 && GetReport.isLoadLegacyReport && GetReport.responseLegacyReport['result_list'] != null && this.state.isready) {
            console.log('Change datatable')
            console.log(GetReport.responseLegacyReport['result_list'])
            var activeArr: any = []
            var N_activeArr: any = []
            for (let i = 0; i < GetReport.responseLegacyReport['result_list'].length; i++) {
                if (GetReport.responseLegacyReport['result_list'][i]['isactive'] == "Y") {
                    activeArr.push(GetReport.responseLegacyReport['result_list'][i])
                } else {
                    N_activeArr.push(GetReport.responseLegacyReport['result_list'][i])
                }
            }
            activeArr.sort(function (a, b) {
                var keyA = a.job_started_on,
                    keyB = b.job_started_on;
                // Compare the 2 dates
                if (keyA > keyB) return -1;
                if (keyA < keyB) return 1;
                return 0;
            });

            N_activeArr.sort(function (a, b) {
                var keyA = a.job_started_on,
                    keyB = b.job_started_on;
                // Compare the 2 dates
                if (keyA > keyB) return -1;
                if (keyA < keyB) return 1;
                return 0;
            });

            var dataArr = activeArr.concat(N_activeArr)
            //var dataArr = GetReport.responseLegacyReport['result_list']
            console.log(dataArr)
            this.setState({
                formData: dataArr,
                isready: false,
                checkReload: true
            })
        }

        if ((this.props.filterKey || this.props.filterCompany || this.props.reportStatus.Active || this.props.reportStatus.Suspend || this.props.reportStatus.Error || this.props.reportStatus.Running || this.props.reportStatus.Finished || this.props.reportStatus.Warning) && this.state.formData.length != 0 && this.state.checkReload) {
            this.setState({
                checkReload: false,
                formData: []
            })
            this.handleSearchDataReport()
        }

        /*if ((this.state.checkFilter || this.state.checkActive || this.state.checkSuspend || this.state.checkError) && this.state.formData.length != 0 && this.state.checkReload) {
            this.setState({
                checkReload: false,
                formData: []
            })
            this.ChangeRefresh()
        }*/

        if (this.state.checkFilter && this.props.filterKey != this.state.keyFilter && !this.state.checkready && this.props.filterKey != undefined && this.props.filterKey != "") {
            this.setState({
                keyFilter: this.props.filterKey
            })
            this.handleFilter()
        }

    }

    async handleSearchDataReport() {
        const { search, resetSearch, filterKey, filterCompany, reportStatus, filterLegacyName } = this.props
        var data: any = this.props.GetReport.responseLegacyReport['result_list'];
        var Arrdata: any = []
        if (reportStatus.Active != "") {
            for (let i = 0; i < data.length; i++) {
                if (data[i].isactive == 'Y') {
                    Arrdata.push(data[i])
                }
            }
        }
        if (filterKey != "") {
            if (Arrdata != null && Arrdata != "") {
                var ArrdataFilter: any = []
                for (let i = 0; i < Arrdata.length; i++) {
                    var upper: number = Arrdata[i].legacyid.indexOf(this.props.filterKey.toUpperCase())
                    //console.log('upper :' + upper)
                    var lower: number = Arrdata[i].legacyid.indexOf(this.props.filterKey.toLowerCase())
                    //console.log('lower :' + upper)
                    if (upper > -1 || lower > -1 || Arrdata[i].legacyid.indexOf(this.props.filterKey) > -1) {
                        ArrdataFilter.push(Arrdata[i])
                    }
                }
                Arrdata = ArrdataFilter;
            } else {
                for (let i = 0; i < data.length; i++) {
                    var upper: number = data[i].legacyid.indexOf(this.props.filterKey.toUpperCase())
                    //console.log('upper :' + upper)
                    var lower: number = data[i].legacyid.indexOf(this.props.filterKey.toLowerCase())
                    //console.log('lower :' + upper)
                    if (upper > -1 || lower > -1 || data[i].legacyid.indexOf(this.props.filterKey) > -1) {
                        Arrdata.push(data[i])
                    }
                }
            }
        }
        if (filterLegacyName != "") {
            if (Arrdata != null && Arrdata != "") {
                var ArrdataFilter: any = []
                for (let i = 0; i < Arrdata.length; i++) {
                    var upper: number = Arrdata[i].legacyname.indexOf(this.props.filterLegacyName.toUpperCase())
                    //console.log('upper :' + upper)
                    var lower: number = Arrdata[i].legacyname.indexOf(this.props.filterLegacyName.toLowerCase())
                    //console.log('lower :' + upper)
                    if (upper > -1 || lower > -1 || Arrdata[i].legacyname.indexOf(this.props.filterLegacyName) > -1) {
                        ArrdataFilter.push(Arrdata[i])
                    }
                }
                Arrdata = ArrdataFilter;
            } else {
                for (let i = 0; i < data.length; i++) {
                    var upper: number = data[i].legacyname.indexOf(this.props.filterLegacyName.toUpperCase())
                    //console.log('upper :' + upper)
                    var lower: number = data[i].legacyname.indexOf(this.props.filterLegacyName.toLowerCase())
                    //console.log('lower :' + upper)
                    if (upper > -1 || lower > -1 || data[i].legacyname.indexOf(this.props.filterLegacyName) > -1) {
                        Arrdata.push(data[i])
                    }
                }
            }
        }

        if (filterCompany != "") {
            if (Arrdata != null && Arrdata != "") {
                var ArrdataFilter: any = []
                for (let i = 0; i < Arrdata.length; i++) {
                    var upper: number = Arrdata[i].companycode.indexOf(this.props.filterCompany.toUpperCase())
                    //console.log('upper :' + upper)
                    var lower: number = Arrdata[i].companycode.indexOf(this.props.filterCompany.toLowerCase())
                    //console.log('lower :' + upper)
                    if (upper > -1 || lower > -1 || Arrdata[i].companycode.indexOf(this.props.filterCompany) > -1) {
                        ArrdataFilter.push(Arrdata[i])
                    }
                }
                Arrdata = ArrdataFilter;
            } else {
                for (let i = 0; i < data.length; i++) {
                    var upper: number = data[i].companycode.indexOf(this.props.filterCompany.toUpperCase())
                    //console.log('upper :' + upper)
                    var lower: number = data[i].companycode.indexOf(this.props.filterCompany.toLowerCase())
                    //console.log('lower :' + upper)
                    if (upper > -1 || lower > -1 || data[i].companycode.indexOf(this.props.filterCompany) > -1) {
                        Arrdata.push(data[i])
                    }
                }
            }
        }

        if (reportStatus.Suspend != "") {
            if (Arrdata != null && Arrdata != "") {
                var ArrdataFilter: any = []
                for (let i = 0; i < Arrdata.length; i++) {
                    if (Arrdata[i].hassuspend == 'Y') {
                        ArrdataFilter.push(Arrdata[i])
                    }
                }
                Arrdata = ArrdataFilter;
            } else {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].hassuspend == 'Y') {
                        Arrdata.push(data[i])
                    }
                }
            }
        }


        var ArrdataFilter: any = []
        if (reportStatus.Error != "") {
            if (reportStatus.Active == "" && filterKey == "" && filterLegacyName == "" && filterCompany == "" && reportStatus.Suspend == "") {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].step1_status == "ERROR" || data[i].step2_status == "ERROR" || data[i].step3_status == "ERROR" || data[i].step4_status == "ERROR") {
                        ArrdataFilter.push(data[i])
                    }
                }
            }
            else if (Arrdata != null && Arrdata != "") {
                for (let i = 0; i < Arrdata.length; i++) {
                    if (Arrdata[i].step1_status == "ERROR" || Arrdata[i].step2_status == "ERROR" || Arrdata[i].step3_status == "ERROR" || Arrdata[i].step4_status == "ERROR") {
                        ArrdataFilter.push(Arrdata[i])
                    }
                }
            } else {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].step1_status == "ERROR" || data[i].step2_status == "ERROR" || data[i].step3_status == "ERROR" || data[i].step4_status == "ERROR") {
                        Arrdata.push(data[i])
                    }
                }
            }
        }

        if (reportStatus.Running != "") {
            if (reportStatus.Active == "" && filterKey == "" && filterLegacyName == "" && filterCompany == "" && reportStatus.Suspend == "") {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].step1_status == "RUNNING" || data[i].step2_status == "RUNNING" || data[i].step3_status == "RUNNING" || data[i].step4_status == "RUNNING") {
                        ArrdataFilter.push(data[i])
                    }
                }
            }
            else if (Arrdata != null && Arrdata != "") {
                for (let i = 0; i < Arrdata.length; i++) {
                    if (Arrdata[i].step1_status == "RUNNING" || Arrdata[i].step2_status == "RUNNING" || Arrdata[i].step3_status == "RUNNING" || Arrdata[i].step4_status == "RUNNING") {
                        ArrdataFilter.push(Arrdata[i])
                    }
                }
            } else {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].step1_status == "RUNNING" || data[i].step2_status == "RUNNING" || data[i].step3_status == "RUNNING" || data[i].step4_status == "RUNNING") {
                        Arrdata.push(data[i])
                    }
                }
            }
        }

        if (reportStatus.Warning != "") {
            if (reportStatus.Active == "" && filterKey == "" && filterLegacyName == "" && filterCompany == "" && reportStatus.Suspend == "") {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].step1_status == "WARNING" || data[i].step2_status == "WARNING" || data[i].step3_status == "WARNING" || data[i].step4_status == "WARNING") {
                        ArrdataFilter.push(data[i])
                    }
                }
            }
            else if (Arrdata != null && Arrdata != "") {
                for (let i = 0; i < Arrdata.length; i++) {
                    if (Arrdata[i].step1_status == "WARNING" || data[i].step2_status == "WARNING" || data[i].step3_status == "WARNING" || data[i].step4_status == "WARNING") {
                        ArrdataFilter.push(Arrdata[i])
                    }
                }
            } else {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].step1_status == "WARNING" || data[i].step2_status == "WARNING" || data[i].step3_status == "WARNING" || data[i].step4_status == "WARNING") {
                        Arrdata.push(data[i])
                    }
                }
            }
        }

        if (reportStatus.Finished != "") {
            if (reportStatus.Active == "" && filterKey == "" && filterLegacyName == "" && filterCompany == "" && reportStatus.Suspend == "") {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].status == "FINISHED") {
                        ArrdataFilter.push(data[i])
                    }
                }
            }
            else if (Arrdata != null && Arrdata != "") {
                for (let i = 0; i < Arrdata.length; i++) {
                    if (Arrdata[i].status == "FINISHED") {
                        ArrdataFilter.push(Arrdata[i])
                    }
                }
            } else {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].status == "FINISHED") {
                        Arrdata.push(data[i])
                    }
                }
            }
        }

        if (ArrdataFilter.length > 0) {
            Arrdata = ArrdataFilter;
        }

        if (reportStatus.Active == "" && reportStatus.Suspend == "" && reportStatus.Error == "" && reportStatus.Running == "" && reportStatus.Finished == "" && reportStatus.Warning == "" && filterKey == "" && filterCompany == "" && filterLegacyName == "") {
            this.setState({
                formData: data,
            })
        } else {
            this.setState({
                formData: Arrdata,
            })
        }


        resetSearch()
        this.props.callbackkey()
    }

    async handleActive() {
        console.log('start check active')
        console.log(this.state.checkFilter)
        var PRDdata: any = []
        if (this.state.checkFilter) {
            for (let i = 0; i < this.state.formData.length; i++) {
                if (this.state.formData[i].isactive == 'Y') {
                    PRDdata.push(this.state.formData[i])
                }
            }
        } else {
            this.setState({
                formData: [],
            })
            for (let i = 0; i < this.props.GetReport.responseLegacyReport['result_list'].length; i++) {
                if (this.props.GetReport.responseLegacyReport['result_list'][i]['isactive'] == 'Y') {
                    PRDdata.push(this.props.GetReport.responseLegacyReport['result_list'][i])
                }
            }
        }
        this.setState({
            formData: PRDdata,
            checkActive: true
        })
        console.log(PRDdata)

        this.props.callbackkey()
        //this.forceUpdate()
    }

    async handleSuspend() {
        console.log('start check Suspend')
        console.log(this.state.checkFilter)
        var PRDdata: any = []
        for (let i = 0; i < this.state.formData.length; i++) {
            if (this.state.formData[i].hassuspend == 'Y') {
                PRDdata.push(this.state.formData[i])
            }
        }
        this.setState({
            formData: PRDdata,
            checkSuspend: true
        })
        console.log(PRDdata)

        this.props.callbackkey()
        //this.forceUpdate()
    }

    async handleError() {
        console.log('start check Error')
        console.log(this.state.checkFilter)
        var Arrdata: any = []
        for (let i = 0; i < this.state.formData.length; i++) {
            if (this.state.formData[i].step1_status == "ERROR" || this.state.formData[i].step2_status == "ERROR" || this.state.formData[i].step3_status == "ERROR" || this.state.formData[i].step4_status == "ERROR") {
                Arrdata.push(this.state.formData[i])
            }
            //console.log(this.state.formData[i].legacyid.indexOf(this.props.filterKey))
        }
        this.setState({
            formData: Arrdata,
            checkError: true
        })
        console.log(Arrdata)

        this.props.callbackkey()
        //this.forceUpdate()
    }

    async handleFilter() {
        console.log('start check filter')
        var Arrdata: any = []
        if (!this.state.checkActive) {
            for (let i = 0; i < this.state.formData.length; i++) {
                console.log('upper :' + this.props.filterKey.toUpperCase())
                var upper: number = this.state.formData[i].legacyid.indexOf(this.props.filterKey.toUpperCase())
                console.log('lower :' + this.props.filterKey.toLowerCase())
                var lower: number = this.state.formData[i].legacyid.toLowerCase().indexOf(this.props.filterKey.toLowerCase())
                if (upper > -1 || lower > -1 || this.state.formData[i].legacyid.indexOf(this.props.filterKey) > -1) {
                    Arrdata.push(this.state.formData[i])
                }
            }
        } else {
            for (let i = 0; i < this.props.GetReport.responseLegacyReport['result_list'].length; i++) {
                var upper: number = this.props.GetReport.responseLegacyReport['result_list'][i].legacyid.indexOf(this.props.filterKey.toUpperCase())
                var lower: number = this.props.GetReport.responseLegacyReport['result_list'][i].legacyid.indexOf(this.props.filterKey.toLowerCase())
                if (upper > -1 || lower > -1 || this.props.GetReport.responseLegacyReport['result_list'][i].legacyid.indexOf(this.props.filterKey) > -1) {
                    Arrdata.push(this.props.GetReport.responseLegacyReport['result_list'][i])
                }
            }
        }
        this.setState({
            formData: Arrdata,
            checkFilter: true
        })
        this.props.callbackkey()
    }


    async ChangeRefresh() {
        var data: any = this.props.GetReport.responseLegacyReport['result_list'];
        var Arrdata: any = []
        if (this.state.checkActive) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].isactive == 'Y') {
                    Arrdata.push(data[i])
                }
            }
        }
        if (this.state.checkFilter) {
            if (Arrdata != null && Arrdata != "") {
                var ArrdataFilter: any = []
                for (let i = 0; i < Arrdata.length; i++) {
                    var upper: number = Arrdata[i].legacyid.indexOf(this.props.filterKey.toUpperCase())
                    //console.log('upper :' + upper)
                    var lower: number = Arrdata[i].legacyid.indexOf(this.props.filterKey.toLowerCase())
                    //console.log('lower :' + upper)
                    if (upper > -1 || lower > -1 || Arrdata[i].legacyid.indexOf(this.props.filterKey) > -1) {
                        ArrdataFilter.push(Arrdata[i])
                    }
                }
                Arrdata = ArrdataFilter;
            } else {
                for (let i = 0; i < data.length; i++) {
                    var upper: number = data[i].legacyid.indexOf(this.props.filterKey.toUpperCase())
                    //console.log('upper :' + upper)
                    var lower: number = data[i].legacyid.indexOf(this.props.filterKey.toLowerCase())
                    //console.log('lower :' + upper)
                    if (upper > -1 || lower > -1 || data[i].legacyid.indexOf(this.props.filterKey) > -1) {
                        Arrdata.push(data[i])
                    }
                }
            }

        }
        if (this.state.checkSuspend) {
            if (Arrdata != null && Arrdata != "") {
                var ArrdataFilter: any = []
                for (let i = 0; i < Arrdata.length; i++) {
                    if (Arrdata[i].hassuspend == 'Y') {
                        ArrdataFilter.push(Arrdata[i])
                    }
                }
                Arrdata = ArrdataFilter;
            } else {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].hassuspend == 'Y') {
                        Arrdata.push(data[i])
                    }
                }
            }
        }
        if (this.state.checkError) {
            if (Arrdata != null && Arrdata != "") {
                var ArrdataFilter: any = []
                for (let i = 0; i < Arrdata.length; i++) {
                    if (Arrdata[i].step1_status == "ERROR" || Arrdata[i].step2_status == "ERROR" || Arrdata[i].step3_status == "ERROR" || Arrdata[i].step4_status == "ERROR") {
                        ArrdataFilter.push(Arrdata[i])
                    }
                }
                Arrdata = ArrdataFilter;
            } else {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].step1_status == "ERROR" || data[i].step2_status == "ERROR" || data[i].step3_status == "ERROR" || data[i].step4_status == "ERROR") {
                        Arrdata.push(data[i])
                    }
                }
            }

        }

        this.setState({
            formData: Arrdata,
        })
        this.props.callbackkey()
    }

    continuteHandleClick(sid: string, companycode: string, legacyid: string) {
        this.setState({
            isready: true,
            formData: []
        })
        this.props.requestGetLegacyReport(true, "CLEAR", "", "")
        this.props.UseLoading(true)
        this.props.callbackStopAutoRefresh()
        fetch(`/v1/job/resume?sid=` + sid + '&company_code=' + companycode + '&legacy_id=' + legacyid, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('LG_APPLICATION'),
            },
        })
            .then((response) => {
                this.props.requestGetLegacyReport(true, "POST", "", this.state.companyCode)
                this.props.UseLoading(false)
                console.log(response)
                if (!response.ok) {
                    alert(new Error(response.json() as any))
                } else {
                    Swal.fire({
                        title: 'สำเร็จ',
                        icon: 'success',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'ตกลง',
                        allowOutsideClick: false
                    }).then((result) => {
                        if (result.value) {
                            //this.props.requestGetLegacyReport(true, "POST", "", this.state.companyCode)
                            //this.props.callbackStartAutoRefresh()
                            return;
                        }
                    })
                }
            })
            .then((data) => {
                console.log(data)
                //alert(data)
            })
            .catch(error => {
                console.log('errorrrr')
                this.setState({
                    isready: false
                })
                Swal.fire({
                    title: 'ไม่สำเร็จ',
                    text: error,
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'ตกลง',
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.value) {

                    }
                })
            });
    }

    runImmediatelyHandleClick(sid: string, companycode: string, legacyid: string, legacytype: string, important_job: string) {
        //console.log(important_job)
        //console.log(this.state.formData);
        var text = 'ยืนยันคำสั่งรีรันหรือไม่ ?';
        const filtered = this.state.formData.filter(item => item.sid == sid && item.companycode == companycode && item.legacyid == legacyid);
        console.log(filtered);
        if (filtered && filtered.length > 0 && filtered[0].legacy_criteria) {
            console.log(filtered[0].legacy_criteria)
            if (filtered[0].legacy_criteria) {
                var text = 'Legacy นี้จะรีรันได้ก็ต่อเมื่อ Legacy ID: ' + filtered[0].legacy_criteria + " Success<br>"  + text;
            }
        }

        Swal.fire({
            title: 'ต้องการรีรันหรือไม่',
            html: text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ใช่',
            cancelButtonText: 'ไม่'
        }).then((result) => {
            //console.log(result.isConfirmed);
            if (result.isConfirmed) {
                if (important_job && important_job.toLowerCase() != 'true') {
                    let job_password = '1q0p2w9o';
                    Swal.fire({
                        title: 'กรุณาระบุรหัสผ่าน',
                        input: 'password',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ยืนยัน',
                        cancelButtonText: 'ยกเลิก',
                        showLoaderOnConfirm: true,
                        preConfirm: (password) => {
                            if (password == null || password == "") {
                                Swal.showValidationMessage(
                                    'กรุณากรอกรหัสผ่าน'
                                )
                            }
                            else if (password == job_password) {
                                this.runImmediatelyHandle(sid, companycode, legacyid, legacytype)
                            }
                            else {
                                Swal.showValidationMessage(
                                    'รหัสผ่านไม่ถูกต้อง'
                                )
                            }
                        }
                    })
                }
                else {
                    this.runImmediatelyHandle(sid, companycode, legacyid, legacytype)
                }
            }
        })
    }

    runImmediatelyHandle(sid: string, companycode: string, legacyid: string, legacytype: string) {
        this.setState({
            isready: true,
            formData: []
        })
        this.props.requestGetLegacyReport(true, "CLEAR", "", "")
        this.props.UseLoading(true)
        this.props.callbackStopAutoRefresh()
        fetch(`/v1/lis-server/run-immediate?sid=` + sid + '&company_code=' + companycode + '&legacy_id=' + legacyid + '&legacy_type=' + legacytype, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('LG_APPLICATION'),
            },
        })
            .then((response) => {
                this.props.requestGetLegacyReport(true, "POST", "", this.state.companyCode)
                this.props.UseLoading(false)
                console.log(response)
                if (!response.ok) {
                    alert(new Error(response.json() as any))
                } else {
                    Swal.fire({
                        title: 'สำเร็จ',
                        icon: 'success',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'ตกลง',
                        allowOutsideClick: false
                    }).then((result) => {
                        if (result.value) {
                            //this.props.requestGetLegacyReport(true, "POST", "", this.state.companyCode)
                            //this.props.callbackStartAutoRefresh()
                            return;
                        }
                    })
                }
            })
            .then((data) => {
                console.log(data)
                //alert(data)
            })
            .catch(error => {
                console.log('errorrrr')
                this.setState({
                    isready: false
                })
                Swal.fire({
                    title: 'ไม่สำเร็จ',
                    text: error,
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'ตกลง',
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.value) {

                    }
                })
            });
    }

    checkPassword() {
        let password: string = (document.getElementById("passwordconfirm") as HTMLInputElement).value;
        if (this.state.passwordFromApi == password) {
            Swal.fire({
                title: 'สำเร็จ',
                icon: 'success',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'ตกลง',
                allowOutsideClick: false
            }).then((result) => {
                if (result.value) {
                    //this.props.requestGetLegacyReport(true, "POST", "", this.state.companyCode)
                    //this.props.callbackStartAutoRefresh()
                    this.setState({
                        isShowAlertConfirmModal: false
                    })
                    return;
                }
            })
        }
        else {
            Swal.fire({
                title: 'พาสเวิร์ดไม่ถูกต้อง',
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'ตกลง',
                allowOutsideClick: false
            }).then((result) => {
                return;
            })
        }
    }

    CancelHandleClick(sid: string, companycode: string, legacyid: string, job_instance_no: string) {
        this.setState({
            isready: true,
            formData: []
        })
        this.props.requestGetLegacyReport(true, "CLEAR", "", "")
        this.props.UseLoading(true)
        this.props.callbackStopAutoRefresh()
        fetch(`/v1/lis-server/cancel?sid=` + sid + '&company_code=' + companycode + '&legacy_id=' + legacyid + '&job_instance_no=' + job_instance_no, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('LG_APPLICATION'),
            },
        })
            .then((response) => {
                this.props.requestGetLegacyReport(true, "POST", "", this.state.companyCode)
                this.props.UseLoading(false)
                console.log(response)
                return response
            })
            .then(async (data) => {
                console.log(data)
                if (!data.ok) {
                    const jsonData = await data.json();
                    if ((jsonData.message as string).includes('Cannot found running job')) {
                        Swal.fire({
                            title: 'Success!',
                            icon: 'success',
                            html: 'ไม่พบการทำงานของ Job นี้<br>อาจจะต้องรอสักครู่เพื่อให้ระบบทำการยกเลิกการทำงาน',
                            showCancelButton: false,
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false
                        }).then((result) => {
                            if (result.value) {
                                //this.props.requestGetLegacyReport(true, "POST", "", this.state.companyCode)
                                //this.props.callbackStartAutoRefresh()
                                return;
                            }
                        })
                    } else {
                        Swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            showCancelButton: false,
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false
                        }).then((result) => {
                            if (result.value) {
                                //this.props.requestGetLegacyReport(true, "POST", "", this.state.companyCode)
                                //this.props.callbackStartAutoRefresh()
                                return;
                            }
                        })
                    }
                } else {
                    Swal.fire({
                        title: 'Success!',
                        icon: 'success',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false
                    }).then((result) => {
                        if (result.value) {
                            //this.props.requestGetLegacyReport(true, "POST", "", this.state.companyCode)
                            //this.props.callbackStartAutoRefresh()
                            return;
                        }
                    })
                }
            })
            .catch(error => {
                console.log('errorrrr')
                this.setState({
                    isready: false
                })
                Swal.fire({
                    title: 'ไม่สำเร็จ',
                    text: error,
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'ตกลง',
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.value) {

                    }
                })
            });
    }

    runStepHandleClick(sid: string, companycode: string, legacytype: string, legacyid: string, job_instance_no: string, step: string, important_job: string) {
        //console.log(important_job)
        Swal.fire({
            title: 'ต้องการรีรันหรือไม่',
            text: 'ยืนยันคำสั่งรีรันหรือไม่ ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ใช่',
            cancelButtonText: 'ไม่'
        }).then((result) => {
            //console.log(result.isConfirmed);
            if (result.isConfirmed) {
                if (important_job && important_job.toLowerCase() != 'true') {
                    let job_password = '1q0p2w9o';
                    Swal.fire({
                        title: 'กรุณาระบุรหัสผ่าน',
                        input: 'password',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ยืนยัน',
                        cancelButtonText: 'ยกเลิก',
                        showLoaderOnConfirm: true,
                        preConfirm: (password) => {
                            if (password == null || password == "") {
                                Swal.showValidationMessage(
                                    'กรุณากรอกรหัสผ่าน'
                                )
                            }
                            else if (password == job_password) {
                                this.runStepHandle(sid, companycode, legacytype, legacyid, job_instance_no, step)
                            }
                            else {
                                Swal.showValidationMessage(
                                    'รหัสผ่านไม่ถูกต้อง'
                                )
                            }
                        }
                    })
                }
                else {
                    this.runStepHandle(sid, companycode, legacytype, legacyid, job_instance_no, step)
                }
            }
        })
    }

    runStepHandle(sid: string, companycode: string, legacytype: string, legacyid: string, job_instance_no: string, step: string) {
        //Swal.fire({
        //    title: 'ต้องการรีรันหรือไม่',
        //    text: 'คุณต้องการรีรัน Legacy ID นี้หรือไม่ ?',
        //    icon: 'warning',
        //    showCancelButton: true,
        //    confirmButtonColor: '#3085d6',
        //    confirmButtonText: 'ตกลง',
        //    cancelButtonText: 'ไม่ตกลง',
        //    cancelButtonColor: '#FF0000',
        //    allowOutsideClick: false
        //}).then((result) => {
        //    if (result.value) {
        this.setState({
            isready: true,
            formData: []
        })
        this.props.requestGetLegacyReport(true, "CLEAR", "", "")
        this.props.UseLoading(true)
        //this.props.callbackStopAutoRefresh()
        fetch(`/v1/lis-server/run-step?sid=` + sid + '&company_code=' + companycode + '&legacy_type=' + legacytype + '&legacy_id=' + legacyid + '&job_instance_no=' + job_instance_no + '&step=' + step, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('LG_APPLICATION'),
            },
        })
            .then((response) => {
                this.props.requestGetLegacyReport(true, "POST", "", this.state.companyCode)
                this.props.UseLoading(false)
                console.log(response)
                return response
            })
            .then((data) => {
                if (!data.ok) {
                    Swal.fire({
                        title: 'Error!',
                        icon: 'error',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false
                    }).then((result) => {
                        if (result.value) {
                            //this.props.requestGetLegacyReport(true, "POST", "", this.state.companyCode)
                            //this.props.callbackStartAutoRefresh()
                            return;
                        }
                    })
                } else {
                    Swal.fire({
                        title: 'Success!',
                        icon: 'success',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false
                    }).then((result) => {
                        if (result.value) {
                            //this.props.requestGetLegacyReport(true, "POST", "", this.state.companyCode)
                            //this.props.callbackStartAutoRefresh()
                            return;
                        }
                    })
                }
            })
            .catch(error => {
                console.log('errorrrr')
                this.setState({
                    isready: false
                })
                Swal.fire({
                    title: 'ไม่สำเร็จ',
                    text: error,
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'ตกลง',
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.value) {

                    }
                })
            });
        //    }
        //})
    }

    handleCloseTemModal = () => {
        if (this.state.isShowTempModal == false) {
            this.setState({
                isShowTempModal: true
            })

        } else {
            this.setState({
                isShowTempModal: false
            })
        }
    }

    handleCloseAlertConfirmModal = () => {
        if (this.state.isShowAlertConfirmModal == false) {
            this.setState({
                isShowAlertConfirmModal: true
            })

        } else {
            this.setState({
                isShowAlertConfirmModal: false
            })
        }
    }

    handleClickTemModal = (id) => {
        //console.log('id')
        //console.log(id)
        if (this.state.isShowTempModal == false) {
            this.setState({
                isShowTempModal: true,
                isSelectVal: id
            })

        }
    }

    public formatSystemLogMessage(message?: string): React.ReactNode {
        if (!message) return '';

        const splitedMessage = message
            .replace('\r', '')
            .split('\n');

        const jsxMessage = splitedMessage
            .map(message => {
                if (message === '' || message === null) {
                    return <br />
                }

                if (message.includes('success') || message.includes('warning') || message.includes('error')) {
                    return <span className={(message.includes('success') ? 'text-success' : (message.includes('warning') ? 'text-warning' : 'text-danger'))}>{message}</span>
                }

                return <p className={`${(message.toLowerCase().includes('processstep')) && 'text-primary'}`}>{message}</p>
            })

        return jsxMessage;
    }

    public getSendEmailStatusFromMessage(message?: string) {
        if (!message) return <span>-</span>;

        if (message.includes('success')) {
            return <span className="text-success">Success</span>;
        }

        if (message.includes('error')) {
            return <span className="text-danger">Error</span>;
        }

        return <span>-</span>
    }

    render() {
        const { GetReport } = this.props
        console.log(this.state.formData)
        return (
            <div style={{ overflowX: 'scroll' }}>
                <Table className="table-bordered table-hover custom-table-list table-responsive" size="sm" style={{ width: '100%', overflow: 'inherit' }}>
                    <thead>
                        <tr style={{ width: '100%' }} className="text-center table-active thead-light font-weight-bold require-field">
                            <th style={{ width: '2%' }}>Menu</th>
                            <th style={{ width: '2%' }}>รายงาน</th>
                            <th style={{ width: '4%' }}>Company Code</th>
                            {/*<th style={{ width: '4%' }}>Chain Job ID</th>*/}
                            {/*<th style={{ width: '4%' }}>Chain Job Name</th>*/}
                            {/*<th style={{ width: '4%' }}>Chain Job</th>*/}
                            <th style={{ width: '6%' }}>Legacy ID </th>
                            <th style={{ width: '6%' }}>Legacy Name</th>
                            <th style={{ width: '8%' }}>Job Instanceno</th>
                            <th style={{ width: '3%' }}>Legacy Type</th>
                            <th style={{ width: '5%' }}>Status (lastest)</th>
                            <th style={{ width: '6%' }}>Job Start</th>
                            <th style={{ width: '6%' }}>Job Finished On</th>
                            <th style={{ width: '6%' }}>Next Fire</th>
                            <th style={{ width: '5%' }}>Load Files Status</th>
                            {/*<th style={{ width: '5%' }}>Conversion Status</th>*/}
                            {/* <th style={{ width: '7%' }}>Step 1 started on</th> */}
                            <th style={{ width: '5%' }}>Call Function Status</th>
                            {/* <th style={{ width: '7%' }}>Step 2 started on</th> */}
                            <th style={{ width: '5%' }}>Return Files Status</th>
                            {/* <th style={{ width: '7%' }}>Step 3 started on</th> */}
                            <th style={{ width: '5%' }}>Function Status</th>
                            <th style={{ width: '8%' }}>Chain</th>
                            <th style={{ width: '5%' }}>Send Email Status</th>
                            <th style={{ width: '5%' }}>Upload DMS Status</th>
                            <th style={{ width: '2%' }}>Message</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!GetReport.isLoadLegacyReport ? <tr style={{ width: '100%' }}><td colSpan={99} style={{ background: "rgba(209, 250, 221, 1)", color: "black", fontSize: '10pt', textAlign: "center" }}><Spinner animation="border" size="sm" />&nbsp;&nbsp;Loading...</td></tr> : <tr></tr>}
                        {GetReport.isLoadLegacyReport && GetReport.statusLegacyReport != 200 ? <tr><td colSpan={99} style={{ background: "#b7b7a4", color: "black", fontSize: '10pt', textAlign: "center" }}>&nbsp;&nbsp;No Data...</td></tr> : <tr></tr>}
                        {this.state.formData.length != 0 && this.state.formData.map((item: LegacyReportModels.LegacyReport, idx: any) => {
                            var srcMonitor = "/legacydetail?company_code=" + item.companycode + "&legacy_id=" + item.legacyid + "&job_no=" + item.job_instanceno + "&legacytype=" + item.legacytype
                            return (
                                <tr key={idx} style={{ backgroundColor: item.isactive == "N" && item.hassuspend == "Y" ? '#E6F1EF' : item.hassuspend == "Y" ? '#E4B1AB' : '' }}>
                                    <td className='text-center'>
                                        <DropdownButton id="dropdown-basic-button" title={<FaListUl />} variant="info" size='sm' onFocus={(e) => this.props.callbackStopAutoRefresh()}>
                                            <Dropdown.Header>{item.legacyid}</Dropdown.Header>
                                            <Dropdown.Divider />
                                            <Dropdown.Item>
                                                <ButtonGroup>
                                                    <Button
                                                        variant="primary"
                                                        size="sm"
                                                        onClick={(_event) => window.open(srcMonitor, '_blank', 'noopener,noreferrer')}
                                                    >
                                                        <FaEye />
                                                    </Button>
                                                    {/* <Link to={srcMonitor} target="_blank" className="btn btn-primary btn-sm"><FaEye /></Link> */}
                                                    <Button variant={item.hassuspend == 'N' ? "primary" : "secondary"} size="sm" className="mx-1" data-toggle="tooltip" data-placement="bottom" title="Run immediately" disabled={item.hassuspend == 'N' ? false : true} onClick={(e) => this.runImmediatelyHandleClick(item.sid, item.companycode, item.legacyid, item.legacytype, item.important_job)}><FaPlayCircle /></Button>
                                                    <Button variant={item.hassuspend == 'Y' ? "info" : "secondary"} size="sm" className="mx-1" data-toggle="tooltip" data-placement="bottom" title="Continue" disabled={item.hassuspend == 'Y' ? false : true} onClick={(e) => this.continuteHandleClick(item.sid, item.companycode, item.legacyid)}><FaForward /></Button>
                                                    <Button variant={item.step2_status == 'RUNNING' ? "danger" : "secondary"} size="sm" className="mx-1" data-toggle="tooltip" data-placement="bottom" title="Stop" onClick={(e) => this.CancelHandleClick(item.sid, item.companycode, item.legacyid, item.job_instanceno)}><FaStopCircle /></Button>
                                                    {/*{(item.legacytype == "DMS_WAIT" || item.legacytype == "DMS") &&*/}
                                                    {/*    <Button variant="dark" size="sm" className="mx-1" data-toggle="tooltip" data-placement="bottom" title="view" onClick={(e) => this.handleClickView(item.companycode, item.legacyid, item.job_instanceno)} ><FaFile /></Button>*/}
                                                    {/*}*/}
                                                </ButtonGroup>
                                            </Dropdown.Item>
                                        </DropdownButton>
                                    </td>
                                    <td className="text-center">{idx + 1}</td>
                                    <td className="text-center">{item.companycode}</td>
                                    {/*<td className="text-center"></td>*/}
                                    {/*<td className="text-center"></td>*/}
                                    {/*<td className="text-center"></td>*/}
                                    <td>{item.legacyid}</td>
                                    <td>{item.legacyname}</td>
                                    <td>{item.job_instanceno}</td>
                                    <td className="text-center">{item.legacytype}</td>
                                    <td className={taskStatusColour(String(item.status)) + ' text-center'}>{item.status}</td>
                                    <td className="text-center">{formatYMDToDMY(String(item.job_started_on))}</td>
                                    <td className="text-center">{formatYMDToDMY(String(item.job_finished_on))}</td>
                                    <td className="text-center">{resetFormatDMY(String(item.next_fire))}</td>
                                    {/*<td className={taskStatusColour(String(item.step1_status)) + ' text-center'}>{item.step1_status == 'ERROR' ? <div><Button variant="primary" size="sm" className="mx-1" data-toggle="tooltip" data-placement="bottom" title="Refresh" onClick={(e) => this.runStepHandleClick(item.sid, item.companycode, item.legacytype, item.legacyid, item.job_instanceno, '1')}><FaRedoAlt style={{ cursor: 'pointer' }} color="white" /></Button></div> : ''}{item.step1_status}</td>*/}
                                    <td className={taskStatusColour(String(item.step1_status)) + ' text-center'}>{item.step1_status}</td>
                                    {/*<td className={taskStatusColour(String(item.step5_status)) + ' text-center'}>{item.step5_status == 'ERROR' ? <div><Button variant="primary" size="sm" className="mx-1" data-toggle="tooltip" data-placement="bottom" title="Refresh" onClick={(e) => this.runStepHandleClick(item.sid, item.companycode, item.legacytype, item.legacyid, item.job_instanceno, '5', item.important_job)}><FaRedoAlt style={{ cursor: 'pointer' }} color="white" /></Button></div> : ''}{item.step5_status}</td>*/}
                                    {/* <td className="text-center">{formatYMDToDMY(String(item.step1_started_on))}</td> */}
                                    <td className={taskStatusColour(String(item.step2_status)) + ' text-center'}>{item.step2_status == 'ERROR' ? <div><Button variant="primary" size="sm" className="mx-1" data-toggle="tooltip" data-placement="bottom" title="Refresh" onClick={(e) => this.runStepHandleClick(item.sid, item.companycode, item.legacytype, item.legacyid, item.job_instanceno, '2', item.important_job)}><FaRedoAlt style={{ cursor: 'pointer' }} color="white" /></Button></div> : ''}{item.step2_status}</td>
                                    {/* <td className="text-center">{formatYMDToDMY(String(item.step2_started_on))}</td> */}
                                    <td className={taskStatusColour(String(item.step3_status)) + ' text-center'}>{item.step3_status == 'ERROR' ? <div><Button variant="primary" size="sm" className="mx-1" data-toggle="tooltip" data-placement="bottom" title="Refresh" onClick={(e) => this.runStepHandleClick(item.sid, item.companycode, item.legacytype, item.legacyid, item.job_instanceno, '3', item.important_job)}><FaRedoAlt style={{ cursor: 'pointer' }} color="white" /></Button></div> : ''}{item.step3_status}</td>
                                    {/* <td className="text-center">{formatYMDToDMY(String(item.step3_started_on))}</td> */}
                                    <td className={taskStatusColour(String(item.step4_status)) + ' text-center'}>
                                        <div className="d-inline-block">
                                            {
                                                item.step4_status == 'ERROR' ?
                                                    //<DropdownButton id="dropdown-basic-button" title={<FaListUl />} variant="outline-light" size='sm' onFocus={(e) => this.props.callbackStopAutoRefresh()}>
                                                    //    <Dropdown.Header>{item.legacyid}</Dropdown.Header>
                                                    //    <Dropdown.Divider />
                                                    //    <Dropdown.Item>

                                                    //    </Dropdown.Item>
                                                    //</DropdownButton>
                                                    <div>
                                                        <Button variant="primary" size="sm" className="mx-1" data-toggle="tooltip" data-placement="bottom" title="Refresh" onClick={(e) => this.runStepHandleClick(item.sid, item.companycode, item.legacytype, item.legacyid, item.job_instanceno, '4', item.important_job)}><FaRedoAlt color="white" style={{ cursor: 'pointer' }} /></Button>
                                                    </div>
                                                    : ''}
                                            {item.step4_status}
                                        </div>
                                    </td>
                                    <td className={(item.chain_legacy ? taskStatusColour(String(item.status)) : '') + ' text-center'}>
                                        {item.chain_legacy}
                                    </td>
                                    <td className={taskStatusColour(String(item.send_email_status)) + ' text-center'}>
                                        {item.send_email_status}
                                    </td>
                                    <td className={taskStatusColour(String(item.upload_dms_status)) + ' text-center'}>
                                        {item.upload_dms_status}
                                    </td>
                                    <td data-toggle="tooltip" data-placement="bottom" title={item.message}>&nbsp;&nbsp;
                                        {item.message != "" && item.message != null &&
                                            <div className="text-center">
                                                <Button variant="info" className="btn-sm" onClick={() => this.handleClickTemModal(idx)}><FaSearch /></Button>
                                            </div>
                                        }
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
                {/*Modal Message Error*/}
                <Modal show={this.state.isShowTempModal} onHide={this.handleCloseTemModal} size="lg" backdrop="static" keyboard={false}>
                    <Modal.Header translate="yes" closeButton>
                        <Modal.Title>
                            {this.state.formData.length != 0 && this.state.isSelectVal != null &&
                                this.state.formData[this.state.isSelectVal].job_instanceno
                            }
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Table className="table-bordered table-hover table-responsive" size="sm" style={{ width: '100%', overflow: 'auto' }}>
                            {/*<thead>
                                <tr style={{ width: '100%' }} className="text-center table-active thead-light font-weight-bold require-field">
                                    <th style={{ width: '20%' }}>Name</th>
                                    <th style={{ width: '700px' }}>Data</th>
                                </tr>
                            </thead>*/}
                            <tbody>
                                {this.state.formData.length != 0 && this.state.isSelectVal != null &&
                                    <>
                                        <tr>
                                            <td style={{ width: '800px', whiteSpace: 'pre-line' }}>{this.state.formData[this.state.isSelectVal].message}</td>
                                        </tr>
                                    </>
                                }

                            </tbody>
                        </Table>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" onClick={this.handleCloseTemModal}>
                            <FaTimesCircle /> Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/*Modal Alert Confirm*/}
                <Modal show={this.state.isShowAlertConfirmModal} onHide={this.handleCloseAlertConfirmModal} size="lg" backdrop="static" keyboard={false}>
                    <Modal.Header translate="yes" closeButton>
                        <Modal.Title>Login</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col>
                                <Form.Label className="font-weight-bold">Password</Form.Label>
                                <InputGroup className="mb-3">
                                    <FormControl id="passwordconfirm" aria-describedby="basic-addon3" />
                                </InputGroup>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => this.checkPassword()}>
                            <FaTimesCircle /> ยืนยัน
                        </Button>
                        <Button variant="danger" onClick={this.handleCloseAlertConfirmModal}>
                            <FaTimesCircle /> ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default connect((state: ApplicationState) => ({ ...state.legacyReport, ...state.Loading, ...state.lisCommand }), ({ ...LegacyReportStore.actionCreators, ...LoadingStore.actionCreators }))(LegacyReportTable)
